import type { TableColumns } from '@ff-it/ui';
import type { QueryParams } from 'components/ControlledTable/types';
import type { BlockState } from 'modules/campaign/block/types';
import { createOptions } from 'options';
export const campaignViews = ['all', 'managed', 'planned'] as const;
export const campaignViewOptions = createOptions(campaignViews);
export type CampaignsView = (typeof campaignViews)[number];

export type StageIndicators = {
  empty_campaigns: number;
  unassigned_blocks: number;
  assigned_blocks: number;
  submitted_blocks: number;
  pending_blocks: number;
  live_blocks: number;
  ended_blocks: number;
};

export const viewFilterMap: Record<CampaignsView, string> = {
  all: 'MANAGED_OR_PLANNED',
  managed: 'MANAGED',
  planned: 'PLANNED',
};

export type StageGroupConfig = {
  label: string;
  blockState: BlockState;
  children: Array<keyof StageIndicators>;
};

export type StageItemConfig = {
  label: string;
  blockState: BlockState;
  url: string;
  columns: TableColumns<any>;
  queryParms: QueryParams;
};

export type StageConfig = StageGroupConfig | StageItemConfig;
